import View from './view';
export const TabBarCustom = View;
